(function () {
  var money = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' });
  function fmt(cents) { return money.format((cents || 0) / 100); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initGallery(root) {
    var slides = $$('[data-slide]', root);
    var thumbs = $$('[data-thumb]', root);
    var counter = $('[data-gallery-count]', root);
    if (!slides.length) return;
    var current = 0;
    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === current;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        var v = $('video', s);
        if (v) { if (on) { v.play().catch(function () {}); } else { v.pause(); } }
      });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === current ? 'true' : 'false'); });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }
    $$('[data-gallery-prev]', root).forEach(function (b) { b.addEventListener('click', function () { show(current - 1); }); });
    $$('[data-gallery-next]', root).forEach(function (b) { b.addEventListener('click', function () { show(current + 1); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var stage = $('[data-gallery-stage]', root);
    var sx = null;
    if (stage) {
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx; sx = null;
        if (dx < -40) show(current + 1); else if (dx > 40) show(current - 1);
      });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(current + 1);
        if (e.key === 'ArrowLeft') show(current - 1);
      });
    }
    show(0);
  }

  function initProduct(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var unitEl = $('[data-unit]', root);
    var perEl = $('[data-per-bun]', root);
    var ctaLabel = $('[data-cta-label]', root);
    var cta = $('[data-cta]', root);
    var bump = $('[data-bump]', root);
    var notify = $('[data-notify]', root);
    var buyArea = $('[data-buy-area]', root);
    var sticky = document.querySelector('[data-sticky]');
    var threshold = parseInt(root.getAttribute('data-free-shipping') || '5000', 10);

    function variantById(id) { for (var i = 0; i < data.variants.length; i++) { if (String(data.variants[i].id) === String(id)) return data.variants[i]; } return data.variants[0]; }
    function selected() { var r = $('input[name="bk-variant"]:checked', root); return variantById(r ? r.value : data.variants[0].id); }
    function update() {
      var v = selected();
      if (idInput) idInput.value = v.id;
      var bumpOn = bump && bump.checked && !bump.disabled;
      var total = v.price + (bumpOn ? parseInt(bump.getAttribute('data-price'), 10) : 0);
      if (priceEl) { priceEl.textContent = fmt(v.price); priceEl.classList.toggle('bk-price__now--long', fmt(v.price).length > 9); }
      if (unitEl) unitEl.textContent = (v.unit ? v.unit + ', ' : '') + 'inkl. MwSt., zzgl. Versand';
      if (perEl) { perEl.textContent = v.per || ''; perEl.hidden = !v.per; }
      if (ctaLabel) ctaLabel.textContent = v.available ? 'In den Warenkorb – ' + fmt(total) : 'Ausverkauft';
      if (cta) cta.disabled = !v.available;
      if (notify) notify.hidden = v.available;
      if (buyArea) buyArea.hidden = !v.available;
      $$('[data-meter]').forEach(function (m) { renderMeter(m, total, threshold); });
      if (sticky) {
        var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = fmt(v.price);
        var st = $('[data-sticky-title]', sticky); if (st) st.textContent = v.short || v.title;
        var sb = $('[data-sticky-btn]', sticky); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft'; }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('input[name="bk-variant"]', root).forEach(function (r) { r.addEventListener('change', update); });
    if (bump) bump.addEventListener('change', update);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = selected();
        if (!v.available) return;
        var items = [{ id: v.id, quantity: 1 }];
        if (bump && bump.checked && !bump.disabled) items.push({ id: parseInt(bump.value, 10), quantity: 1 });
        if (cta) cta.setAttribute('aria-busy', 'true');
        addItems(items).finally(function () { if (cta) cta.removeAttribute('aria-busy'); });
      });
    }
    if (sticky) {
      var sb = $('[data-sticky-btn]', sticky);
      if (sb) sb.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
      if (cta && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }).observe(cta);
      }
    }
    update();
  }

  function renderMeter(m, total, threshold) {
    var rest = Math.max(0, threshold - total);
    var pct = Math.min(100, Math.round(total / threshold * 100));
    var label = $('[data-meter-label]', m);
    var fill = $('[data-meter-fill]', m);
    if (label) label.textContent = rest === 0 ? 'Versandkostenfrei, läuft!' : 'Noch ' + fmt(rest) + ' bis Gratisversand';
    if (fill) fill.style.width = pct + '%';
  }

  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'); });
  }

  var drawer = null;
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; var c = $('[data-drawer-close]', drawer); if (c) c.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  function refreshCart(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
      if (drawer) renderDrawer(cart);
      if (open) openDrawer();
      return cart;
    });
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderDrawer(cart) {
    var list = $('[data-drawer-lines]', drawer);
    var title = $('[data-drawer-title]', drawer);
    var sum = $('[data-drawer-sum]', drawer);
    var foot = $('[data-drawer-foot]', drawer);
    var upsells = $('[data-drawer-upsells]', drawer);
    var threshold = parseInt(drawer.getAttribute('data-free-shipping') || '5000', 10);
    if (title) title.textContent = 'Im Warenkorb (' + cart.item_count + ')';
    if (!cart.items.length) {
      list.innerHTML = '<p class="bk-drawer__empty">Dein Warenkorb ist noch leer.</p>';
      if (foot) foot.hidden = true;
    } else {
      if (foot) foot.hidden = false;
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
        return '<div class="bk-line"><img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' +
          '<div class="bk-line__main"><span><span class="bk-line__title">' + esc(it.product_title) + '</span><br>' +
          (it.variant_title ? '<span class="bk-line__variant">' + esc(it.variant_title) + '</span>' : '') + '</span>' +
          '<div class="bk-line__row"><div class="bk-qty"><button type="button" aria-label="Menge verringern" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '">–</button>' +
          '<span aria-live="polite">' + it.quantity + '</span><button type="button" aria-label="Menge erhöhen" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '">+</button></div>' +
          '<strong class="bk-line__price">' + fmt(it.final_line_price) + '</strong></div></div></div>';
      }).join('');
    }
    if (sum) sum.textContent = fmt(cart.total_price);
    $$('[data-meter]', drawer).forEach(function (m) { renderMeter(m, cart.total_price, threshold); });
    if (upsells) {
      var inCart = cart.items.map(function (i) { return i.variant_id; });
      $$('[data-upsell]', upsells).forEach(function (u) { u.hidden = inCart.indexOf(parseInt(u.getAttribute('data-upsell'), 10)) !== -1; });
    }
  }

  function initDrawer() {
    drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      if (q) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: q.getAttribute('data-qty'), quantity: Math.max(0, parseInt(q.getAttribute('data-to'), 10)) }) })
          .then(function () { return refreshCart(false); });
      }
      var add = e.target.closest('[data-add-variant]');
      if (add) addItems([{ id: parseInt(add.getAttribute('data-add-variant'), 10), quantity: 1 }]);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); }); });
    $$('[data-quick-add]').forEach(function (b) { b.addEventListener('click', function () { addItems([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }]); }); });
  }

  function initShipping() {
    var boxes = $$('[data-cutoff]');
    if (!boxes.length) return;
    function parts(d) {
      var o = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Vienna', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
      return o;
    }
    function isWork(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; }
    function addWork(d, n) { var x = new Date(d.getTime()); while (n > 0) { x = new Date(x.getTime() + 864e5); if (isWork(x)) n--; } return x; }
    function dm(d) { return d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.'; }
    function range(a, b) { return a.getUTCMonth() === b.getUTCMonth() ? a.getUTCDate() + '.–' + dm(b) : dm(a) + '–' + dm(b); }
    var wdShort = new Intl.DateTimeFormat('de-AT', { timeZone: 'UTC', weekday: 'short' });
    var wdLong = new Intl.DateTimeFormat('de-AT', { timeZone: 'UTC', weekday: 'long' });
    function tick() {
      var p = parts(new Date());
      var cutoff = 15 * 60;
      var mins = cutoff - (parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10));
      var today = new Date(Date.UTC(parseInt(p.year, 10), parseInt(p.month, 10) - 1, parseInt(p.day, 10), 12));
      var shipToday = isWork(today) && mins > 0;
      var shipDay = shipToday ? today : addWork(today, 1);
      var tomorrow = shipDay.getTime() - today.getTime() === 864e5;
      var hh = Math.floor(mins / 60), mm = mins % 60;
      var vals = {
        kicker: shipToday ? 'Bestell in den nächsten' : 'Jetzt bestellen, Versand',
        big: shipToday ? (hh > 0 ? hh + ' Std. ' : '') + mm + ' Min.' : (tomorrow ? 'morgen, ' + dm(shipDay) : 'am ' + wdLong.format(shipDay) + ', ' + dm(shipDay)),
        sub: shipToday ? '…dann verschicken wir dein Paket heute noch.' : 'Bis 15 Uhr bestellt, geht’s am selben Werktag raus.',
        d1: shipToday ? 'Heute' : wdShort.format(shipDay) + ' ' + dm(shipDay),
        d2: range(addWork(shipDay, 1), addWork(shipDay, 3)),
        at: range(addWork(shipDay, 1), addWork(shipDay, 3)),
        de: range(addWork(shipDay, 2), addWork(shipDay, 4))
      };
      boxes.forEach(function (b) { $$('[data-cut]', b).forEach(function (el) { el.textContent = vals[el.getAttribute('data-cut')]; }); });
    }
    tick();
    setInterval(tick, 30000);
  }

  function initReviews() {
    $$('[data-rev-pause]').forEach(function (btn) {
      var track = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var paused = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.textContent = paused ? 'Abspielen' : 'Pausieren';
        if (track) track.classList.toggle('is-paused', paused);
      });
    });
  }

  function initMenu() {
    var menu = document.querySelector('[data-menu]');
    if (!menu) return;
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); var f = $('a', menu); if (f) f.focus(); }); });
    $$('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); $$('[data-menu-open]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); }); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.classList.remove('is-open'); });
  }

  function initVideos() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.25 });
    $$('video[data-autoplay]').forEach(function (v) { io.observe(v); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-product]').forEach(initProduct);
    initShipping();
    initReviews();
    initMenu();
    initVideos();
  });
})();
